
<template lang="html">
  <SimpleModal
    :name="modalName"
    class="vq-modal-verification-code"
    :is-open="isOpen"
    @close="close()">
    <template v-slot:header>
      <h2 class="modal-title"><span class="is-bold">{{ $t('components.modalVerificationCode.title') }}</span></h2>
      <button
        type="button"
        class="button is-square is-rounded is-xsmall is-gray-100 modal-close"
        v-on:click="close">
        <span class="css-icon is-close"></span>
      </button>
    </template>
    <template v-slot:content>
      <div class="forms">
        <div class="container has-separator">
          <VqInput
          :label="$t('components.modalVerificationCode.form.code')"
          name="name"
          type="text"
          :errors="errors"
          v-model="code"
          />
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <button type="button" class="button is-small is-gray-400" @click="close">{{ $t('components.modalVerificationCode.form.cancel') }}</button>
      <button
        type="button"
        class="button is-small is-danger is-outline"
        @click="submit">{{ $t('components.modalVerificationCode.form.submit') }}
      </button>
    </template>
  </SimpleModal>
</template>

<script lang="js">
import VSPHERE from '@/api/vsphere';

import SimpleModal from '@/components/SimpleModal.vue';
import VqInput from '@/components/VqInput.vue';


export default {
  name: 'ModalVerificationCode',
  components: {
    SimpleModal,
    VqInput
  },
  props: {
    isOpen: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      modalName: 'verification-code',
      code: '',
      errors: []
    };
  },
  mounted() {
  },
  methods: {
    submit() {
      if (!this.code) {
        this.errors = ['This field is required.']
      } else {
        this.$emit("verification-code", this.code)

      }
    },
    close() {
      this.$emit("close-verification")
      this.code = ''
    }
  },
  computed: {
  },
};
</script>
